import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListIroSectionLinksQuery, useUpdateIroSectionLinkMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'IroSectionLink',
  setup: function setup(__props) {
    // FIXME warning: this file shares lots of similarities with activity-stakeholder-links, we might need to merge them into one table in the future
    var attrs = useAttrs();
    var headers = computed(function () {
      return [{
        value: 'id',
        sortable: true
      }, {
        value: 'section.label'
      }, {
        value: 'actions'
      },
      // { value: 'concernsAndRequirements' },
      {
        value: 'howAffected'
      }, {
        value: 'relationToRo'
      }].filter(function (o) {
        var _attrs$headers;
        return attrs === null || attrs === void 0 ? void 0 : (_attrs$headers = attrs.headers) === null || _attrs$headers === void 0 ? void 0 : _attrs$headers.includes(o.value);
      }).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          sortable: col.sortable || false
        });
      }) || [];
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var search = ref('');
    var variables = computed(function () {
      return {
        iroId: attrs['iro-id'],
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListIroSectionLin = useListIroSectionLinksQuery(variables, computed(function () {
        return {
          enabled: !!variables.value.iroId
        };
      })),
      result = _useListIroSectionLin.result,
      refetch = _useListIroSectionLin.refetch,
      loading = _useListIroSectionLin.loading;
    var items = computed(function () {
      var _result$value$listIro, _result$value;
      return (_result$value$listIro = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listIroSectionLinks) !== null && _result$value$listIro !== void 0 ? _result$value$listIro : [];
    });
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countIroSectionLinks) || 0;
    });
    var _useUpdateIroSectionL = useUpdateIroSectionLinkMutation(),
      updateActivityStakeholderLink = _useUpdateIroSectionL.mutate,
      onDone = _useUpdateIroSectionL.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    return {
      __sfc: true,
      attrs: attrs,
      headers: headers,
      options: options,
      search: search,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      items: items,
      itemCount: itemCount,
      updateActivityStakeholderLink: updateActivityStakeholderLink,
      onDone: onDone
    };
  }
});